// extracted by mini-css-extract-plugin
module.exports = {"hr":"bFHfRBKd","switchMap":"_3biYqcq9"};